(function () {
  'use strict';
  const labels = {
    fr: ['Effectuez 3 paiements de ', 'Afficher les détails Klarna'],
    en: ['3 payments of ', 'Show Klarna details'],
    it: ['Effettua 3 pagamenti da ', 'Mostra i dettagli di Klarna'],
    es: ['Paga en 3 plazos de ', 'Mostrar los detalles de Klarna']
  };
  const patterns = {
    fr: /^3 paiements de (\d+(?:[.,]\d{2})?\s*€)(?:\s|$)/,
    en: /^3 payments of (\d+(?:[.,]\d{2})?\s*€)(?:\s|$)/,
    it: /^3 pagamenti da (\d+(?:[.,]\d{2})?\s*€)(?:\s|$)/,
    es: /^3 plazos de (\d+(?:[.,]\d{2})?\s*€)(?:\s|$)/
  };
  // Klarna alterne deux phrases : « 3 paiements de 9,97 € » (montant dans le texte) et
  // « 3 paiements à 0 % d'intérêt avec Klarna » (aucun montant). Dans le 2e cas on calcule le tiers
  // nous-mêmes à partir du prix, et on ne le fait QUE si Klarna annonce bien un paiement en 3
  // (ni « Ab 5 €/Monat » en Allemagne, ni « payer plus tard » en Belgique : autres offres, on n'y touche pas).
  const zeroInterest = {
    fr: /^3 paiements à 0 ?% d['’]intérêt/i,
    en: /^3 payments at 0 ?% interest/i,
    it: /^3 pagamenti a interessi 0 ?%/i,
    es: /^3 plazos sin intereses/i
  };
  // Sous 10 € on n'affiche aucune offre Klarna (ni notre ligne, ni la phrase de Klarna) : payer un article
  // à 3 ou 5 € en 3 fois n'a pas de sens (décision Rafael 04/10/2026).
  const MIN_PRICE_CENTS = 1000;
  function money(cents, locale) {
    const cur = (typeof window !== 'undefined' && window.Shopify?.currency?.active) || 'EUR';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: cur }).format(cents / 100).replace(/[  ]/g, ' '); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function offer(text, locale, price) {
    const lang = (locale || '').split('-')[0];
    const clean = (text || '').replace(/\s+/g, ' ').trim();
    if (!labels[lang] || !Number.isSafeInteger(Number(price)) || Number(price) <= 0) return null;
    const match = patterns[lang]?.exec(clean);
    if (match) {
      const cents = Math.round(Number(match[1].replace(/\s|€/g, '').replace(',', '.')) * 100);
      if (cents <= 0 || Math.abs(cents * 3 - Number(price)) > 2) return null;
      return { prefix: labels[lang][0], amount: match[1], label: labels[lang][1] };
    }
    if (!zeroInterest[lang]?.test(clean)) return null;
    return { prefix: labels[lang][0], amount: money(Math.ceil(Number(price) / 3), locale), label: labels[lang][1] };
  }
  if (typeof module === 'object' && module.exports) { module.exports = { offer }; return; }
  if (window.etilikKlarnaShortInstalled) return;
  window.etilikKlarnaShortInstalled = true;
  const style = document.createElement('style');
  style.textContent = '.etk-klarna-short{display:flex;align-items:center;gap:10px;width:max-content;max-width:100%;padding:0;margin:0;border:0;background:none;color:#68696c;font:inherit;font-size:13px;line-height:1.5;text-align:left;cursor:pointer;min-height:28px}.etk-klarna-short strong{font-weight:700;color:#111;white-space:nowrap}.etk-klarna-short img{display:block;width:44px;height:auto;flex-shrink:0}.etk-klarna-short:focus-visible{outline:2px solid currentColor;outline-offset:4px}.etk-klarna-short[hidden],klarna-placement.etk-klarna-collapsed{display:none!important}';
  document.head.append(style);
  const states = new Map();
  let nextId = 0;
  function update(el, state) {
    const root = el.shadowRoot;
    const msg = root?.querySelector('[part~="osm-message"]');
    if (root && state.root !== root) {
      state.shadowObserver?.disconnect(); state.root = root;
      state.shadowObserver = new MutationObserver(() => update(el, state));
      state.shadowObserver.observe(root, { subtree: true, childList: true, characterData: true });
    }
    const tiny = Number(el.dataset.purchaseAmount) > 0 && Number(el.dataset.purchaseAmount) < MIN_PRICE_CENTS;
    const current = tiny ? null : offer(msg?.textContent, el.dataset.locale, el.dataset.purchaseAmount);
    const loadingState = tiny ? 'empty' : msg?.textContent?.trim() ? 'ready' : 'pending';
    if (el.dataset.etkKlarnaState !== loadingState) el.dataset.etkKlarnaState = loadingState;
    const signature = JSON.stringify([el.dataset.locale, el.dataset.purchaseAmount, current]);
    if (signature === state.signature) return;
    state.signature = signature;
    state.button.hidden = !current;
    state.button.setAttribute('aria-expanded', 'false');
    el.classList.toggle('etk-klarna-collapsed', tiny || Boolean(current));
    if (!current) return;
    state.copy.replaceChildren(document.createTextNode(current.prefix));
    const strong = document.createElement('strong'); strong.textContent = current.amount; state.copy.append(strong);
    state.button.setAttribute('aria-label', current.prefix + current.amount + '. ' + current.label);
  }
  function mount(el) {
    if (states.has(el)) return;
    const button = document.createElement('button'); button.type = 'button'; button.className = 'etk-klarna-short'; button.hidden = true;
    const copy = document.createElement('span'); const logo = document.createElement('img');
    logo.src = 'https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.svg'; logo.alt = 'Klarna'; logo.width = 44;
    button.append(copy, logo);
    if (!el.id) el.id = 'etk-klarna-offer-' + (++nextId);
    button.setAttribute('aria-controls', el.id); el.before(button);
    const state = { button, copy };
    button.addEventListener('click', () => {const open = button.getAttribute('aria-expanded') !== 'true'; button.setAttribute('aria-expanded', String(open)); el.classList.toggle('etk-klarna-collapsed', !open);});
    state.attributeObserver = new MutationObserver(() => update(el, state));
    state.attributeObserver.observe(el, { attributes: true, attributeFilter: ['data-locale', 'data-purchase-amount'] });
    states.set(el, state); update(el, state);
  }
  function scan() {
    for (const [el, state] of states) {
      if (el.isConnected) { update(el, state); continue; }
      state.shadowObserver?.disconnect(); state.attributeObserver.disconnect(); state.button.remove(); states.delete(el);
    }
    document.querySelectorAll('.product__info-container klarna-placement[data-key="credit-promotion-badge"]').forEach(mount);
  }
  scan(); const observer = new MutationObserver(scan); observer.observe(document.body, { childList: true, subtree: true });
  let poll = window.setInterval(scan, 500);
  window.addEventListener('pagehide', () => {window.clearInterval(poll); observer.disconnect(); for (const state of states.values()) {state.attributeObserver.disconnect(); state.shadowObserver?.disconnect(); state.root = null;}});
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    observer.observe(document.body, { childList: true, subtree: true });
    for (const [el, state] of states) state.attributeObserver.observe(el, { attributes: true, attributeFilter: ['data-locale', 'data-purchase-amount'] });
    scan(); poll = window.setInterval(scan, 500);
  });
})();
